/* TRILLOBEAT — classify only substantial reading copy for Space Grotesk */
(() => {
  const pagePath = window.location.pathname.replace(/\/$/, "");
  document.documentElement.classList.toggle("tb-page-our-story", pagePath === "/pages/our-story");
  document.documentElement.classList.toggle("tb-page-our-process", pagePath === "/pages/our-process");

  const MIN_CHARACTERS = 80;
  const MIN_WORDS = 14;
  const CANDIDATES = "p, li, blockquote";
  const EXCLUDED_ANCESTORS = [
    "header",
    "footer",
    "nav",
    "[role='navigation']",
    "[role='menu']",
    ".announcement-bar",
    ".header-sidebar",
    ".drawer",
    ".section-header",
    ".newsletter",
    ".collection-card",
    ".product-card",
    ".article-card",
    ".blog-post-card",
    ".breadcrumb",
    ".pagination",
    ".price-list",
    ".variant-picker__option-info",
    ".feature-badge"
  ].join(",");

  const headingLikeClass = /(^|\\s)(h[1-6]|heading|title|subtitle|subheading|kicker|eyebrow|caption|label|badge|price|rating)(\\s|$)/i;

  function isFirstProductDescriptionParagraph(element) {
    const description = element.closest("[data-block-type='description']");
    if (!description) return false;

    const firstParagraph = Array.from(description.querySelectorAll("p"))
      .find((paragraph) => paragraph.closest("[data-block-type='description']") === description);

    return firstParagraph === element;
  }

  function isLongReadingCopy(element) {
    if (!(element instanceof HTMLElement) || !element.matches(CANDIDATES)) return false;
    if (!element.closest("main") || element.closest(EXCLUDED_ANCESTORS)) return false;
    if (headingLikeClass.test(element.className || "")) return false;
    if (isFirstProductDescriptionParagraph(element)) return false;

    const text = (element.textContent || "").replace(/\\s+/g, " ").trim();
    const words = text ? text.split(" ").length : 0;

    if (element.children.length === 1 && element.firstElementChild?.tagName === "A") return false;

    return text.length >= MIN_CHARACTERS && words >= MIN_WORDS;
  }

  function classify() {
    document.querySelectorAll("main p, main li, main blockquote").forEach((element) => {
      element.classList.toggle("tb-long-copy", isLongReadingCopy(element));
    });
  }

  let queued = false;
  function queueClassification() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      classify();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", classify, { once: true });
  } else {
    classify();
  }

  new MutationObserver(queueClassification).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
